import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

export default function Blogs({ homeData, pageKey }) {
  const [latestData, setLatestData] = useState(null);
  useEffect(() => {
    if (homeData?.data?.data?.[pageKey]?.blogs_info_data) {
      setLatestData(homeData.data.data[pageKey].blogs_info_data);
    } else if (homeData) {
      setLatestData(homeData);
    } else {
      setLatestData([]);
    }
  }, [homeData, pageKey]);

  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 7000,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "40px",
    responsive: [
      {
        breakpoint: 757,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  const truncateDescription = (text = "") => {
    const words = text.split(" ");
    return words.length > 10 ? words.slice(0, 9).join(" ") + "..." : text;
  };

  const handleClick = () => window.scrollTo(0, 0);

  return (
    <>
      {latestData?.length > 0 && (
        <div className="container">
          <h2>Latest Updates</h2>

          <div className="blog_wrap">
            <Slider {...settings}>
              {latestData.map((blog) => (
                <div className="item" key={blog.id}>
                  <figure>
                    <img
                      src={`${blog.image}?w=400`}
                      srcSet={`
                        ${blog.image}?w=300 300w,
                        ${blog.image}?w=400 400w,
                        ${blog.image}?w=600 600w
                      `}
                      sizes="(max-width: 575px) 100vw, (max-width: 757px) 50vw, 338px"
                      width={338}
                      height={190}
                      loading="lazy"
                      decoding="async"
                      alt={blog.altText}
                    />
                  </figure>

                  <h3>{truncateDescription(blog.title)}</h3>

                  <Link
                    to={`/latest-updates${blog.button_url}`}
                    className="button"
                    onClick={handleClick}
                  >
                    Know more
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
}
